import { updateDataNode } from '@/endpoints'
import { StructureDetailDto, StructureObjectDto } from '@/endpoints/models'
import { QueueData } from '@/endpoints/schemas'
import { RootState } from '@/store'
import { apiCallAction,AppDispatch } from '@/store/utils'
import { InitDataParams } from '@/utils/structureType/useStructureTypeActions'

import { loadNodeOrHistoryVersion } from '../node/utils'
import {
	QUEUE_INIT,
	QUEUE_SAVE,
	QUEUE_SELECT_TAB,
	QUEUE_UPDATE,
} from './constants'
import { QueueTab } from './types'

type QueueInit = {
	editMode: boolean,
	force: boolean,
	node: StructureDetailDto,
	type: typeof QUEUE_INIT
}

type QueueUpdate = {
	node: StructureObjectDto,
	type: typeof QUEUE_UPDATE,
	update: any
}

type QueueSave = {
	metadata: {
		nodeId: number
	},
	payload: void
	type: typeof QUEUE_SAVE
}

interface SelectQueueTab {
	node: StructureObjectDto,
	tab: QueueTab,
	type: typeof QUEUE_SELECT_TAB
}

export const initQueue =
	({
		nodeId,
		editMode = false,
		force = false,
		version,
		envId,
	}: InitDataParams) =>
	async (dispatch: AppDispatch) => {
		const node = await loadNodeOrHistoryVersion(nodeId, version, envId)

		dispatch({
			type: QUEUE_INIT,
			node,
			editMode,
			force,
		} as QueueInit)
	}

export const updateQueue = (
	node: StructureObjectDto,
	update: Partial<QueueData>,
) => ({
	type: QUEUE_UPDATE,
	node,
	update,
})

export const saveQueue =
	(node: StructureObjectDto) =>
	async (dispatch: AppDispatch, getState: () => RootState) => {
		const opened = getState().queue.queues[node.id]

		if (!opened) {
			throw new Error(`Saving unopened state ${node.id}`)
		}

		await dispatch(
			apiCallAction<QueueSave>(
				() =>
					updateDataNode(node.id, {
						data: JSON.stringify(opened.form),
					}),
				QUEUE_SAVE,
				{ nodeId: node.id },
			),
		)
	}

export const selectQueueTab = (node: StructureObjectDto, tab: QueueTab) => ({
	type: QUEUE_SELECT_TAB,
	node,
	tab,
})

export type Actions = QueueInit | QueueUpdate | QueueSave | SelectQueueTab
